import React from 'react';
import CabCrudPage from './CabCrudPage';
import { uploadAdminAsset } from '../../../api/cabsHomepageAdmin';

const AdminCabsHeroBanners = () => (
  <CabCrudPage
    title="Hero Banners"
    description="Manage cabs homepage hero banners."
    resource="hero-banners"
    uploadHandler={uploadAdminAsset}
    enableReorder
    defaultItem={{
      title: '',
      subtitle: '',
      imageUrl: '',
      ctaText: '',
      ctaLink: '',
      sortOrder: 0,
      isActive: true,
    }}
    columns={[
      { key: 'title', label: 'Title' },
      { key: 'ctaText', label: 'CTA' },
      { key: 'sortOrder', label: 'Sort' },
    ]}
    fields={[
      { name: 'title', label: 'Title', required: true },
      { name: 'subtitle', label: 'Subtitle', type: 'textarea', rows: 3 },
      { name: 'imageUrl', label: 'Banner image', type: 'image', required: true },
      { name: 'ctaText', label: 'CTA Text' },
      { name: 'ctaLink', label: 'CTA link' },
      { name: 'sortOrder', label: 'Sort order', type: 'number' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
  />
);

export default AdminCabsHeroBanners;
